export function sortBySequence(rows) {
  return [...rows].sort((rowA, rowB) => {
    const sequenceA = Number(rowA.sequence ?? rowA.Sequence ?? 0);
    const sequenceB = Number(rowB.sequence ?? rowB.Sequence ?? 0);
    return sequenceA - sequenceB;
  });
}
